import {
  vuexOidcCreateStoreModule
} from 'vuex-oidc';

var baseUrl = window.location.origin;
let jsonResponse = null;
// NOTE: If you want to customize how tokens are stored you can use WebStorageStateStore from oidc-client (see bellow)
// Default storage is window.localStorage
// import { WebStorageStateStore } from 'oidc-client'
function setWithExpiry(key, value, ttl) {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    localStorage.removeItem('activeTab');

    return null;
  }
  return item.value;
}

function setConfig() {
  fetch(baseUrl + '/config.json')
    .then((response) => response.json())
    .then((data) => {
      setWithExpiry('_supplierTaksanConfig', data, 86400000);
      location.reload();
    });
}

let check = getWithExpiry('_supplierTaksanConfig');
if (check) {
  jsonResponse = getWithExpiry('_supplierTaksanConfig');
} else {
  localStorage.removeItem('_supplierTaksanConfig');
  setConfig();
}
let oidcConfig = {
  response_mode: 'query',
  authority: jsonResponse.SERVICE_AUTH_EXTERNAL_URL,
  client_id: jsonResponse.CLIENT_ID,
  redirect_uri: jsonResponse.SERVICE_UI_TAKSAAN_SUPPLIER_EXTERNAL_URL + '/Callback',
  response_type: 'code',
  scope: 'openid profile  email phone offline_access ',
  post_logout_redirect_uri: jsonResponse.SERVICE_UI_TAKSAAN_SUPPLIER_EXTERNAL_URL,
  silentRedirectUri: jsonResponse.SERVICE_UI_TAKSAAN_SUPPLIER_EXTERNAL_URL + '/oidc-silent-renew.html',
  automaticSilentRenew: true,
  automaticSilentSignin: true,
  clockSkew: 86700
};
const storeModule = vuexOidcCreateStoreModule(
  oidcConfig,
  // NOTE: If you do not want to use localStorage for tokens, in stead of just passing oidcSettings, you can
  // spread your oidcSettings and define a userStore of your choice
  // {
  //   ...oidcSettings,
  //   userStore: new WebStorageStateStore({ store: window.sessionStorage })
  // },
  // Optional OIDC store settings
  {
    namespaced: true,
    dispatchEventsOnWindow: true,
    publicRoutePaths: ['oidc-callback-error'],
  },
  // Optional OIDC event listeners
  {
    userLoaded: (user) => {
      localStorage.setItem('taksan_supplier_access_token', user.access_token);
    },
    userUnloaded: () => {},
    accessTokenExpiring: () => {
      console.log('accessTokenExpiring');
    },
    accessTokenExpired: () => {
      console.log('accessTokenExpired');
    },
    silentRenewError: () => {
      console.log('silentRenewError');
    },
    userSignedOut: () => {
      console.log("logout event, removing local storage access token")
       localStorage.removeItem('taksan_supplier_access_token');
    },
    oidcError: (payload) => {},
    automaticSilentRenewError: (payload) => {
      console.log(payload);
    },
  }
);

export default storeModule;